import { ComissionReportRequest } from "./comission";
import { PageControl } from "@app-model/page-control";
import { Params } from "@angular/router";
import { ValueConfig } from "./advertisers";
import { BoletoModule } from "../boleto/boleto.module";
import { IdName } from "@app-services/oem-dealer.service";
import { VehicleFilter } from "@app-services/open.service";
import { parseDocumentFromQueryParam } from "@app-utils/document-utils";

export class DealerDetails {
  address?: string;
  addressComplement?: string;
  addressNumber?: string;
  blacklistedByOemDealers?: IdName[];
  cityId?: string;
  cityName?: string;
  comissionReport?: ComissionReportRequest;
  cpfCnpj?: string;
  dealerStats?: DealerStatsHelper;
  district?: string;
  id?: string;
  inactive?: boolean;
  name?: string;
  birthDate?: Date;
  legalName?: string;
  cityRegistration?: string;
  stateRegistration?: string;
  maritalStatus?: string;
  numUsers?: number;
  regionalId?: string;
  regionalName?: string;
  score?: number;
  fastQuoteScore?: number;
  type?: string;
  uf?: string;
  zipCode?: string;
  phoneNumbers?: string[];
  comissionValueCents?: number;
  email?: string;
  segmentClassification?: string[];
  cnaeActivities?: DealerCnaeActivity[];
  createdAt?: Date;
  registeredBy?: string;
  hasCNAE4511?: boolean;
  mobileAppAccessRecently?: boolean;

  whatsappNumber?: string;
  whatsappOptin?: boolean;

  privateDealer?: boolean;
  floorPlanEnabled?: boolean;
  privateAuthorizedByOemDealers?: IdName[];
  privateAuthorizedByOemDealerIds?: string[];
  pendingAuthorization?: boolean;

  superBidBuyerId: boolean;
  superBidAccountCreatedAt?: Date;

  noReceiveOffers: boolean;
  superBidUserStatus: any;
  superBidAccountStatus: string;
  migrationMandatoryAfter: Date;
authenticationMode: string;
reasonForInactivation: string;
denyReason?: string;
inactivatedBy: string;
inactivationDate: Date;
postponementCount?: number;
postponementDates?: Date[];
blockedByMigration?: boolean;
canPostponeMigration?: boolean;
recentHistoryItems?: DealerHistoryItem[];
numHistoryItems?: number;

  constructor() {
    this.inactive = false;
  }
}

export enum DealerHistoryItemType {
  UPDATED = 'UPDATED',
  ACTIVATED = 'ACTIVATED',
  INACTIVATED = 'INACTIVATED',
  BLOCKED_BY_OEM_DEALER = 'BLOCKED_BY_OEM_DEALER',
  UNBLOCKED_BY_OEM_DEALER = 'UNBLOCKED_BY_OEM_DEALER',
  MIGRATION_POSTPONED = 'MIGRATION_POSTPONED',
}

export interface DealerHistoryDiff {
  fieldName: string;
  originalValue?: any;
  newValue?: any;
}

export interface DealerHistoryItem {
  type: DealerHistoryItemType | string;
  createdAt?: Date | string;
  dealerId?: string;
  changedByUserId?: string;
  changedByUsername?: string;
  diff?: DealerHistoryDiff[];
  reason?: string;
  oemDealerId?: string;
  oemDealerName?: string;
}

export interface DealerCnaeActivity {
  code: string;
  activity: string;
}

export enum MaritalStatus {
  MARRIED = "Casado",
  SINGLE = "Solteiro",
  WIDOWER = "Viúvo",
  DIVORCED = "Divorciado",
  SEPARETED = "Separado",
  OTHER = "Outro"
}

export class PageAdminArrematentesRequest {
  actualPage?: number;
  data?: AdminDealerListItem[];
  numberOfPages?: number;
  totalElements?: number;
}

// atualizar estes atributos
const OBJECT_KEY_NAMES = ["cityId", "cityIds", "searchQuery", "statuses", "segments", "boughtStatuses", "superBidAccountStatuses", "types", "uf", "ufs", "lastAccessAtIni", "lastAccessAtEnd", "firstAccessAtIni", 
  "firstAccessAtEnd", "lastBoughtAtIni", "lastBoughtAtEnd", "registrationSources", "privateAuthorizedByOemDealerIds"];
const CPF_KEY = ["cpfCnpj"];
const NUMBER_KEY_NAMES = [];
const BOOLEAN_KEY_NAMES = ["signedContract", "privateDealer", "floorPlanEnabled", "pendingAuthorization", "hasCNAE4511", "mobileAppAccessRecently", "whatsappOptin", "alreadyAccessed", "showModal"];
const IGNORED_KEY_NAMES = ["pageControl"];
const PAGE_CONTROL_KEY_NAMES = ["page", "sortField", "sortDirection"];

const _MS_PER_DAY = 1000 * 60 * 60 * 24;

export class AdminDealerListItem {
  bought?: number;
  cityId?: string;
  cityName?: string;
  hasLatePayment?: boolean;
  id?: string;
  inactive?: boolean;
  lastAccess?: Date;
  latePayments?: number;
  name?: string;
  personalizedOffers?: number;
  score?: number;
  uf?: string;
  users?: number;
  createdAt?: Date;
  firstRegisteredUserAt?: Date;
  boughtRecently?: boolean;
  privateDealer?: boolean;
  floorPlanEnabled?: boolean;
  privateAuthorizedByOemDealers?: IdName[];
  pendingAuthorization?: boolean;
  classificationColor: string;
  greenClassificationLevel: string;
  preRegistration?: boolean;
}

export class AdminDealerFilter {
  cityId?: string;
  cityIds?: string[];
  pageControl?: PageControl;
  searchQuery?: string;
  statuses?: string[];
  boughtStatuses?: string[];
  types?: string[];
  uf?: string;
  ufs?: string[];
  cpfCnpj?: string;
  lastAccessAtIni?: Date;
  lastAccessAtEnd?: Date;
  firstAccessAtIni?: Date;
  firstAccessAtEnd?: Date;
  segments?: string[];
  signedContract?: boolean;
  hasCNAE4511?: boolean;
  regionalId?: string;
  mobileAppAccessRecently?: boolean;
  createdAtIni: string;
  createdAtEnd: string;
  privateDealer?: boolean;
  floorPlanEnabled?: boolean;
  pendingAuthorization?: boolean;
  superBidAccountStatuses?: string[];
  whatsappOptin: boolean;
  lastBoughtAtIni?: Date;
  lastBoughtAtEnd?: Date;
  registrationSources?: string[];
  privateAuthorizedByOemDealerIds?: string[];
  alreadyAccessed: boolean;
  showModal?: boolean;

  toParamMap(): Params {
    const params: Params = {};
    Object.keys(this).forEach((k) => {
      let value: any;
      if (OBJECT_KEY_NAMES.indexOf(k) >= 0) {
        value = JSON.stringify(this[k]);
      } else if (IGNORED_KEY_NAMES.indexOf(k) < 0) {
        value = this[k];
      }
      params[k] = value;
    });
    if (this.pageControl.page) {
      params.page = this.pageControl.page;
    }
    params.sortField = this.pageControl.sortField;
    params.sortDirection = this.pageControl.sortDirection;
    return params;
  }

  updateFromParamMap(params: Params): void {
    Object.keys(params).forEach((k) => {
      let value: any;
      if (OBJECT_KEY_NAMES.indexOf(k) >= 0) {
        value = JSON.parse(params[k]);
      } else if (IGNORED_KEY_NAMES.indexOf(k) < 0) {
        value = params[k];
      }

      if (NUMBER_KEY_NAMES.indexOf(k) >= 0) {
        value = Number(value);
        if (value === Number.NaN) {
          value = undefined;
        }
      } else if (BOOLEAN_KEY_NAMES.indexOf(k) >= 0) {
        value = JSON.parse(value);
      } else if (CPF_KEY.indexOf(k) >= 0) {
        value = parseDocumentFromQueryParam(params[k]);
      }
      if (value !== undefined) {
        if (PAGE_CONTROL_KEY_NAMES.indexOf(k) >= 0) {
          // if (k === "page") {
          //   value--;
          // }
          this.pageControl[k] = value;
        } else {
          this[k] = value;
        }
      }
    });
  }
}

export class AdminDealerSummary {
  accessLastMonthCNAE?: number;
  accessLastMonthPF?: number;
  accessLastMonthPJ?: number;
  activeCarCount?: number;
  activeMotorcycleCount?: number;
  activeTruckCount?: number;
  lastAccessGreen?: number;
  lastAccessYellow?: number;
  lastAccessRed?: number;
  lastAccessGray?: number;
  lastAccessBlack: number;
  greenA: number;
  greenB: number;
  greenC: number;
  total?: number;
  totalActiveWithRegisteredUser?: number;
  totalActiveWithoutRegisteredUser?: number;
  totalFirstAccessLastMonth?: number;
  totalInactive?: number;
  totalPendingAuthorization?: number;
  totalRecentlyBuy?: number;
  migratedToSuperbid?: number;
  hasSuperbidAccount?: number;
  pendingMigrationToSuperbid?: number;
  migrationInProgress?: number;
  showModalCount?: number;
  pendingSuperbidRegistration?: number;
}

export const AdminDealerFilterTypeOrder = [
  "score",
  "updatedAt",
  "name",
  "createdAt",
];


export class DealerStatsHelper {
  acceptedPersonalizedOffers?: number;
  activeBids?: number;
  bids?: number;
  bought?: number;
  cancelledBuy?: number;
  favorites?: number;
  impressions?: number;
  personalizedOffers?: number;
  rejectedPersonalizedOffers?: number;
  uniqueImpressions?: number;
  uniqueViews?: number;
  views?: number;
}

export class EvalDealerFilter {
  oemDealerId?: string;
  pageControl?: PageControl;
  searchQuery?: string;
}

export class EvalDealeHelperPage {
  actualPage?: number;
  data?: EvalDealerHelper[];
  numberOfPages?: number;
  totalElements?: number;
}
export class EvalDealerHelper {
  address?: string;
  addressComplement?: string;
  addressNumber?: string;
  cityId?: string;
  cnpj?: number | string;
  district?: string;
  email?: string;
  id?: string;
  inactive?: boolean;
  name?: string;
  oemDealerId?: string;
  phoneNumbers?: string[];
  zipCode?: string;
}
export class TranscriptionResult {
  text: string;
  confidence: number;
}

export class FipePrice {
  createdAt: string;
  formatedDate: Date;
  createdBy: string;
  id: string;
  month: number;
  monthName: string;
  segment: string[];
  status: string;
  year: number;
}

export type Target = 'MOBILE' | 'DESKTOP';

export type GridFormat = 'INLINE' | 'BLOCK';

export type GridShape = 'SQUARE' | 'RECTANGLE' | 'ROUND';

export type ShelfType = 'BANNER' | 'CAROUSEL' | 'GRID' | 'HTML' | 'VEHICLE' | 'FAST_QUOTE' | 'MAKE' | 'OEM_DEALER';

export interface ImageItem {
  url?: string;
  alt?: string;
  redirectUrl?: string;
}

export interface GridConfig {
  itemsPerRow: number;
  shape: GridShape;
  format: GridFormat;
  lineHeight: number;
}

export interface ShelfRequestDTO {
  id?: string;
  createdBy?: string;
  createdAt?: string;
  updatedAt?: string;
  updatedBy?: string;
  personalizationId?: string;
  order?: number;
  targets?: Target[];
  inactive?: boolean;
  type?: ShelfType;
  name?: string;
  images?: ImageItem[];
  gridConfig?: GridConfig;
  htmlContent?: string;
  vehicleFilter?: VehicleFilter;
  fastQuoteFilter?: VehicleFilter;
  iconContent?: string;
  iconClass?: string;
}

export interface DefaultStatusMessage {
  errorCode?: string;
  message?: string;
  resourcedId?: string;
  success?: boolean;
}

export interface SlugFilter {
  id: string;
  name: string;
  slugUrl: string;
  vehicleFilter: VehicleFilter;
  disabled: boolean;
  createdAt: Date;
  createdBy: string;
  createdByName: string;
  personalizationId: string;
}
